<template>
  <v-card class="tools-view-card">
    <ToolbarHeader :name="'File Converter'"/>
    <v-container>
      <section class="ma-5">
        <v-row justify="center" align="center">
          <v-col cols="12"
                 sm="12"
                 md="4">
            <input hidden
                   id="convertInput"
                   @change="convertFormSubmit($event)"
                   :plain="true"
                   type="file"
                   accept=".csv,.xlsx">
            <v-btn
                @click="openConvertInput()"
                class="w-100"
                color="primary"
            >
              Convert
            </v-btn>
          </v-col>
        </v-row>
      </section>
    </v-container>
  </v-card>
</template>

<script>
import ToolbarHeader from "@/components/Toolbar-Header";
import FileDownload from 'js-file-download';


export default {
  name: "File-Converter",
  components: {ToolbarHeader},
  methods: {
    convertFormSubmit(event) {
      const formData = new FormData();
      formData.append('file', event.target.files[0]);

      this.$store.dispatch('POST_FILE_CONVERTER', {
        form: formData
      })
          .then((response) => {
            FileDownload(response.data, response.headers['x-qsc-filename']);
            this.resetConvertFile();
          })
    },
    openConvertInput() {
      document.getElementById("convertInput").click()
    },
    resetConvertFile() {
      document.getElementById("convertInput").value = "";
    }
  }
}
</script>

<style scoped>

</style>
